import React from 'react';

function About()
{
    return (
        <div className='about-us'>

        <h1 className='module-title'>About us</h1>
        <div className='profile-pictures'> 

<div>
    <div className='profile-pic-willem'> </div>
<p className='name-title'> Willem Peuscher</p>
<p className='work-title'> Partner </p>
<p className='position-title'> Research and Development</p>

</div>
<div>
<div className='profile-pic-dick'> </div>

<p className='name-title'> Dick Nijen Twilhaar            </p>
<p className='work-title'> Director </p>
<p className='position-title'> Product Innovation & Technology</p>

</div>
<div>
<div className='profile-pic-bassam'> </div>
<p className='name-title'> Bassam Alkassar</p>
<p className='work-title'> Director </p>
<p className='position-title'>MENA Operations</p>

</div>
        </div>
         <p>Bound by a shared commitment to improving safety standards and harnessing the power of technological innovation, Willem, Dick, and Bassam
          founded VIRSAT. This visionary company emerged from their extensive careers within the global oil and gas sector, where they gained
           first-hand insight into the critical gaps in traditional safety training methods. Throughout their time working with leading 
           companies in the industry, they witnessed a recurring theme: the urgent need for a more effective and engaging way to train 
           workers on health, safety, security, and environmental (HSSE) policies.</p> 

           <p>Having been deeply affected by their exposure to real-life, tragic safety incidents, the three founders undertook rigorous studies to understand the root causes and 
            contributing factors. Their experiences became catalysts for a greater purpose—helping to drive transformative change in 
            safety practices. Their work was integral to Shell’s monumental shift toward a "best-in-class" safety performance record. 
            Through these challenges, they recognized the significant potential of using advanced visual tools like imagery, animations, 
            and immersive technology to communicate safety protocols in a way that truly resonates with workers on the ground.</p> 

            <p>It was this realization that fueled their passion for developing “transformational learning experiences” utilizing 
                advanced technologies such as virtual reality (VR), interactive animations, and immersive audio-visual content. 
                The partners envisioned a suite of products designed not just for traditional training, but for creating interactive and 
                engaging experiences that actively engage users in learning. These solutions are tailored to deliver real-time, on-the-go 
                learning that workers can access conveniently via smartphones, tablets, and other mobile devices. Whether workers are in 
                the field or in the office, these tools ensure they have immediate access to vital safety training content whenever it’s 
                needed.</p> 
                
                <p>VIRSAT’s core mission is simple yet profound: to empower organizations by providing them with the most effective tools 
                    to implement their HSSE policies and enhance their safety practices. By focusing on the development of state-of-the-art 
                    training products, VIRSAT aims to create safer working environments where employees are not only trained to perform 
                    their tasks with the highest safety standards but also equipped with the knowledge to prevent accidents before they 
                    happen. Through innovative training solutions, VIRSAT is helping to build a future where safety is ingrained in the 
                    culture of every organization, fostering a sustainable and secure workplace for all.</p>
        </div>
    )
}

export default About;